var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseContractAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5022 13.6096C13.8623 13.2435 14.4462 13.2435 14.8064 13.6096L22.6314 21.5645C22.9916 21.9306 22.9916 22.5242 22.6314 22.8903C22.2713 23.2565 21.6874 23.2565 21.3272 22.8903L13.5022 14.9354C13.1421 14.5693 13.1421 13.9757 13.5022 13.6096Z",
    fill: "#5F6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5015 22.8903C13.1413 22.5242 13.1413 21.9306 13.5015 21.5645L21.3265 13.6096C21.6866 13.2434 22.2705 13.2434 22.6307 13.6096C22.9908 13.9757 22.9908 14.5693 22.6307 14.9354L14.8056 22.8903C14.4455 23.2564 13.8616 23.2564 13.5015 22.8903Z",
    fill: "#5F6161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseContractAction);
export default __webpack_public_path__ + "static/media/CloseContractAction.4179b1f8599cd8d4fdb02689a4ea9536.svg";
export { ForwardRef as ReactComponent };